import { formatDateOnly } from './utils';
import { getAdminRegion } from '../constants/stores';

export const NOW_TIME_SLOT_NAME = 'Now';

export const NOW_TIME_SLOT = {
  _id: 'now',
  name: NOW_TIME_SLOT_NAME,
  startTime: '',
};

export const isNowTimeSlot = (name) =>
  String(name || '').trim().toLowerCase() === NOW_TIME_SLOT_NAME.toLowerCase();

export const appendNowTimeSlot = (slots = [], deliveryDate) => {
  const today = formatDateOnly(new Date());
  if (formatDateOnly(deliveryDate) !== today) return slots;
  if (slots.some((s) => isNowTimeSlot(s.name))) return slots;
  return [NOW_TIME_SLOT, ...slots];
};

export const getCurrencyMeta = (adminData) => {
  if (getAdminRegion(adminData) === 'india' || adminData === true) {
    return { code: 'INR', symbol: '₹', label: 'INR' };
  }
  return { code: 'QAR', symbol: 'QAR ', label: 'QAR' };
};

export const formatPrice = (amount, adminData) => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return '---';
  const { code } = getCurrencyMeta(adminData);
  const formatted = value % 1 === 0
    ? value.toString()
    : value.toFixed(2).replace(/0$/, '');
  if (code === 'INR') return `₹${formatted}`;
  return `QAR ${formatted}`;
};

export const formatOrderTotal = (total, adminData) => {
  if (total === null || total === undefined || total === '') return '-';
  const amount = Number(total);
  if (!Number.isFinite(amount)) return '-';
  return formatPrice(amount, adminData);
};

/** Editable base amount input label (UI only). */
export const getSubTotalInputLabel = (adminData) => {
  const { label } = getCurrencyMeta(adminData);
  return `Sub Total (${label})`;
};

/** @deprecated use getSubTotalInputLabel */
export const getTotalInputLabel = (adminData) => {
  const { label } = getCurrencyMeta(adminData);
  return `Order Total (${label})`;
};

export const getDeliveryChargeInputLabel = () => {
  const { label } = getCurrencyMeta();
  return `Delivery Charge (${label})`;
};

export const getDiscountInputLabel = () => {
  const { label } = getCurrencyMeta();
  return `Discount (${label})`;
};

/** Base amount before delivery/discount (prefers stored subTotal). */
export const getOrderSubTotal = (bill = {}) => {
  const delivery = Math.max(0, Number(bill?.deliveryCharge) || 0);
  const discount = Math.max(0, Number(bill?.discount) || 0);
  if (bill?.subTotal != null && bill.subTotal !== '' && Number.isFinite(Number(bill.subTotal))) {
    return Math.max(0, Number(bill.subTotal) || 0);
  }
  const total = Math.max(0, Number(bill?.totalPrice) || 0);
  return Math.max(0, Math.round((total - delivery + discount) * 100) / 100);
};

export const getOrderDiscount = (bill = {}) => Math.max(0, Number(bill?.discount) || 0);

/** totalPrice = max(0, subTotal + deliveryCharge - discount) */
export const computePayableTotal = ({ subTotal, deliveryCharge, discount } = {}) => {
  const base = Math.max(0, Number(subTotal) || 0);
  const delivery = Math.max(0, Number(deliveryCharge) || 0);
  const disc = Math.max(0, Number(discount) || 0);
  return Math.max(0, Math.round((base + delivery - disc) * 100) / 100);
};

/** Persist bill with totalPrice = subTotal + deliveryCharge - discount. */
export const buildBillAmounts = ({ subTotal, deliveryCharge, discount } = {}) => {
  const base = Math.max(0, Number(subTotal) || 0);
  const delivery = Math.max(0, Number(deliveryCharge) || 0);
  const disc = Math.max(0, Number(discount) || 0);
  return {
    subTotal: base,
    deliveryCharge: delivery,
    discount: disc,
    totalPrice: computePayableTotal({ subTotal: base, deliveryCharge: delivery, discount: disc }),
  };
};

export const getPriceInputLabel = (adminData) => {
  const { label } = getCurrencyMeta(adminData);
  return `Price (${label})`;
};

export {
  formatPaymentType,
  isAdvancePaidPayment,
  getAdvancePaidAmount,
  getBalancePaymentAmount,
  getStatusMeta,
  getNextOrderStatus,
  getStatusStepperLabel,
  getStatusSubtext,
  isLastOrderStatus,
} from './orderConfigHelpers';
